import React from 'react';

export default function Quote() {
  return (
    <section className="quote">
      <p>
        Mathematics is not about numbers, equations, computations, or
        algorithms: it is about understanding.
      </p>
      <p>- William Paul Thurston</p>
    </section>
  );
}
